import { NetworkStatus } from "@apollo/client";
import { useTimeTrackingItemsQuery } from "@src/__generated__/graphql";
import { onError } from "@src/utils/apollo";
import { toApiDate } from "@src/utils/dates";
import type { Store } from "../store";

const pollInterval = 60 * 1000; // 1 minute

export const useFetchTimeTrackingItems = (store: Store) => {
  const { loading, refetch, networkStatus } = useTimeTrackingItemsQuery({
    notifyOnNetworkStatusChange: true,
    pollInterval,
    variables: {
      user_id: store.userId.value,
      from: toApiDate(store.stepper.startOfWeek),
      to: toApiDate(store.stepper.endOfWeek),
    },
    onCompleted(data) {
      store.setTimeTrackingItems(data);
    },
    ...onError(),
  });

  store.timeTrackingItemsRefetch = refetch;

  // We just want to respond to loading state
  if (
    [
      NetworkStatus.loading,
      NetworkStatus.setVariables,
      NetworkStatus.ready,
    ].includes(networkStatus)
  ) {
    store.setTimeTrackingItemsLoading(loading);
  }
};
